<div class="bp-modal mod-lg">
  <bp-modal-header [cssStyle]="'mod-general'">
    <a right class="button-weight" (click)="close()" (keydown.enter)="close()" [tabIndex]="0">
      {{ "close" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="contact-header pt-30 pb-30">
      <span class="monogram">{{ monogram }}</span>
      <span class="font-size-20 mt-10">{{ contactName }}</span>
      <a class="button-weight mt-20 items-center" (click)="edit()" (keydown.enter)="edit()" [tabIndex]="0">
        <span class="bpi__icon-edit stronger-text mr-10"></span>
        {{ "edit_contact" | translate }}
      </a>
    </div>
    @if (contactFields.length > 0) {
      <div class="bp-modal-body-section pt-0 pb-25 mod-fullwidth">
        <label class="form-label text-light mt-20 ml-40">{{ "addresses" | translate }}</label>
        @for (address of contactFields; track address) {
          <contact-address-list-item
            [address]="address"
            [icon]="getIconByAddress(address.getType())"
            (onSend)="send(data, address)">
          </contact-address-list-item>
        }
      </div>
    }
  </div>
</div>
